// C777ES-9295 - Scheduled maintenance bar.
// Hardcoded for now; the intention is to move this to the CMS later, keeping the same shape.

export default {
  // Start of the maintenance, with an explicit UTC offset so every visitor counts down to the same moment
  startsAt: '2026-10-12T23:00:00+02:00',

  // How many minutes before `startsAt` the bar becomes visible
  warningMinutes: 10,

  // Set to true to show the bar regardless of the warning window (testing only)
  alwaysShow: false,

  title: 'Mantenimiento programado',
  lines: [
    'En 10 minutos comenzaremos unas tareas de mantenimiento y la web dejará de estar disponible temporalmente.',
    'Te recomendamos finalizar tu sesión antes de que comience.'
  ]
}
